export const Permissions = {
    USER_VIEW: 'user:view',
    MENTOR_VIEW: 'mentor:view',
    ADMIN_VIEW: 'admin:view',
};